import { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { enviarContacto } from '../services/api';
import styles from '../styles/pages.module.css';

export default function Contacto() {
  const [form, setForm] = useState({ nombre: '', email: '', asunto: '', mensaje: '' });
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await enviarContacto(form);
      setMensaje('Mensaje enviado correctamente. Nos pondremos en contacto pronto.');
      setForm({ nombre: '', email: '', asunto: '', mensaje: '' });
    } catch (err) {
      setError(err.response?.data?.message || 'Error al enviar el mensaje');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: '#FAF7F2' }}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <span className={styles.eyebrow} style={{ color: '#FFB380' }}>Hablemos</span>
          <h1>¿Cómo podemos ayudarte?</h1>
          <p>Estamos aquí para resolver cualquier duda sobre tu mudanza.</p>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.contactLayout}>
            {/* Contact Info */}
            <div>
              <h2 style={{ fontSize: '1.75rem', marginBottom: '2rem', color: '#0F4C75' }}>Contacta con nosotros</h2>

              <div className={styles.contactInfoBlock}>
                <div className={styles.contactRow}>
                  <div className={styles.contactIcon}><FaPhone /></div>
                  <div>
                    <div className={styles.contactRowLabel}>Teléfono</div>
                    <a href="tel:+34691604880" className={styles.contactRowValueBig}>691 60 48 80</a>
                  </div>
                </div>

                <div className={styles.contactRow}>
                  <div className={styles.contactIcon}><FaEnvelope /></div>
                  <div style={{ minWidth: 0 }}>
                    <div className={styles.contactRowLabel}>Email</div>
                    <a href="mailto:info@mudanzasbritosa.com" className={styles.contactRowValueBig}>info@mudanzasbritosa.com</a>
                  </div>
                </div>

                <div className={styles.contactRow}>
                  <div className={styles.contactIcon}><FaMapMarkerAlt /></div>
                  <div>
                    <div className={styles.contactRowLabel}>Dirección</div>
                    <div className={styles.contactRowValue}>C. Río Duero<br/>28934 Móstoles, Madrid</div>
                  </div>
                </div>

                <div className={styles.contactRow}>
                  <div className={styles.contactIcon}><FaClock /></div>
                  <div>
                    <div className={styles.contactRowLabel}>Horario</div>
                    <div className={styles.contactRowValue}>Lunes a Domingo, 8:00 – 22:00</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <div>
              <form onSubmit={handleSubmit} className={styles.form} style={{ margin: 0, maxWidth: 'none' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1.5rem', color: '#0F4C75' }}>Envíanos un mensaje</h2>

                {mensaje && <div className={styles.successMessage}>{mensaje}</div>}
                {error && <div className={styles.errorMessage}>{error}</div>}

                <div className={styles.formGroup}>
                  <label>Nombre</label>
                  <input type="text" name="nombre" value={form.nombre} onChange={handleChange} required />
                </div>
                <div className={styles.formGroup}>
                  <label>Email</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} required />
                </div>
                <div className={styles.formGroup}>
                  <label>Asunto</label>
                  <input type="text" name="asunto" value={form.asunto} onChange={handleChange} required />
                </div>
                <div className={styles.formGroup}>
                  <label>Mensaje</label>
                  <textarea name="mensaje" value={form.mensaje} onChange={handleChange} required style={{ minHeight: '140px' }} />
                </div>
                <button type="submit" disabled={loading} className={styles.formButton}>
                  {loading ? 'Enviando...' : 'Enviar mensaje'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <section style={{ padding: '1rem 0 4rem' }}>
        <div className={styles.container}>
          <div style={{ borderRadius: '1rem', overflow: 'hidden', boxShadow: '0 8px 24px rgba(15, 76, 117, 0.1)' }}>
            <iframe
              title="Ubicación Britosa Mudanzas"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3034.0887954869434!2d-3.8632638!3d40.3242929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd418b44e6d5cccf%3A0x1234567890abc!2sC.%20R%C3%ADo%20Duero%2C%2028934%20M%C3%B3stoles%2C%20Madrid!5e0!3m2!1ses!2ses!4v1234567890"
              width="100%"
              height="380"
              style={{ border: 0, display: 'block' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
